import React, {CSSProperties, MouseEventHandler} from "react";

import './ChatControlButton.scss'
import IconInterface from "../../icons/IconInterface";
import NoMediaDeviceIcon from '../../icons/svg/no-media-device.svg?react'

export type ChatControlButtonProps = {
    onClick: MouseEventHandler<HTMLButtonElement>
    icon: IconInterface
    title?: string|null
    activeTitle?: string|null
    active?: boolean
    disabled?: boolean
    /** Inert but full-colour (RISKS.md/P2.26) — for a device that is present but blocked, where
     *  `disabled`'s grey-out would be wrong: the warning badge already says what is wrong. */
    blocked?: boolean
    className?: string|null
    counter?: number
    hasWarning?: boolean
    /** Hover copy explaining the warning (RISKS.md/P2.28). Renders ONLY alongside `hasWarning` —
     *  passing this alone shows nothing. */
    warningTooltip?: string|null
    style?: CSSProperties
}

export default ({ icon, onClick, active = false, disabled = false, blocked = false, title = null, activeTitle = null, className = null, counter = 0, hasWarning = false, warningTooltip = null, style = {} }: ChatControlButtonProps) => {
    const iconNode = icon.get(active)

    const titleToShow = active
        ? activeTitle || title
        : title

    const classNames = (className || '').split(' ').map(chunk => chunk.trim()).filter(chunk => !!chunk)
    if (disabled && !classNames.includes('disabled')) {
        classNames.push('disabled')
    }
    if (blocked && !classNames.includes('blocked')) {
        classNames.push('blocked')
    }
    if (!active) {
        classNames.push('inactive')
    }

    return (
        <button onClick={blocked ? undefined : onClick} className={'action-button ' + classNames.join(' ')} style={style}>
            { iconNode }
            { counter ? (
                <i className="counter">{counter}</i>
            ) : ''}
            { hasWarning ? (
                <i className="warning">
                    <NoMediaDeviceIcon/>
                </i>
            ) : ''}
            {/* Spans, not divs: a <button> takes only phrasing content, so a browser hoists a <div>
                out of it and the tooltip detaches. Revealed on hover by CSS — no state here. */}
            { hasWarning && warningTooltip ? (
                <span className="device-warning-tooltip" aria-hidden="true">
                    <span className="device-warning-tooltip__frame">{warningTooltip}</span>
                    {/* Open path: the fill closes it, the stroke draws only the slanted sides — a `Z`
                        would redraw the seam at the bubble. sweep-flag 0, or the arc notches the tip
                        inward; points derive from a virtual apex at (12, 12.941), landing the 2px
                        round exactly on y=12. */}
                    <svg className="device-warning-tooltip__arrow" width="24" height="12" viewBox="0 0 24 12">
                        <path d="M0 0 L10.533 11.360 A2 2 0 0 0 13.467 11.360 L24 0"/>
                    </svg>
                </span>
            ) : ''}
            {titleToShow && (
                <span className="action-button__tooltip">{titleToShow}</span>
            )}
        </button>
    )
}